<template>
  <div class="page-self">
    <a-row :gutter="[24, 24]">
      <a-col :span="8">
        <a-card title="用户须知">
           
          <p>
            自我承诺学习是用户根据继续教育大纲自定义学习方向和内容，可包含自我看书学习、政策解读、学术讨论等。
          </p>
          <p>用户只需要根据情况添加记录即可获得学时。</p>
          <p>具体学时规则如下：</p>

          <p>
            <a-badge status="success" />每条记录
            <span class="color-green">+1 学时</span>
          </p>
          <p>
            <a-badge status="processing" />每天记录
            <span class="color-blue">+3 学时</span>
          </p>
          <p>
            <a-badge status="error" />最高可获得
            <span class="color-red">+24 学时</span>
          </p>
        </a-card>
      </a-col>
      <a-col :span="16">
        <a-form-model
          ref="formInline"
          :model="formInline"
          @submit="handleSubmit"
          :rules="rules"
          @submit.native.prevent
        >
          <a-form-model-item label="学习内容描述(必填)" prop="contents">
            <a-textarea
              v-model="formInline.contents"
              :auto-size="{ minRows: 5, maxRows: 8 }"
              placeholder="例如：本人承诺xxxx年xx月xx日，通过XX方式学习XX，获得了XX相关知识。"
            >
            </a-textarea>
          </a-form-model-item>
          <a-form-model-item label="自学照片">
            <a-upload
              action="http://api.szn.sznykt.com/uploads.html"
              list-type="picture-card"
              :file-list="fileList"
              @preview="handlePreview"
              @change="handleChange"
            >
              <div v-if="fileList.length < 6">
                <a-icon type="plus" />
                <div class="ant-upload-text">选择图片</div>
              </div>
            </a-upload>
            <a-modal
              :visible="previewVisible"
              :footer="null"
              @cancel="handleCancel"
            >
              <img alt="example" style="width: 100%" :src="previewImage" />
            </a-modal>
          </a-form-model-item>
          <a-form-model-item>
            <a-button type="primary" html-type="submit"> 确认提交 </a-button>
          </a-form-model-item>
        </a-form-model>
      </a-col>
    </a-row>
  </div>
</template>
<style lang="less" scoped>
.page-self{
    height: calc(100vh - 260px);
}
</style>
<script>
function getBase64(file) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result);
    reader.onerror = (error) => reject(error);
  });
}
const rules = {
  contents: [
    { required: true, message: "请输入学习内容描述", trigger: "blur" },
  ],
};
export default {
  props: {
    planId: {
      type: Number,
      default: 0,
    },
    workId: {
      type: Number,
      default: 0,
    },
    pwid: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      rules,
      formInline: {
        contents: "",
        meterial: "",
        userid: this.$store.get("userid", 0),
        planid: this.planId,
        workid: this.workId,
        pwid: this.pwid,
      },
      previewVisible: false,
      previewImage: "",
      fileList: [],
    };
  },
  methods: {
    handleSubmit() {
      this.$refs.formInline.validate((valid) => {
        if (valid) {
          let meterial = [];
          this.fileList.map((item) => {
            if (item.response.errcode === 0) {
              meterial.push(item.response.data.url);
            }
          });

          this.formInline.meterial =
            meterial.length > 0 ? meterial.join(",") : "";
          console.log(this.formInline);
          this.$request.common.learn
            .selfstudy(this.formInline)
            .then(({ data }) => {
              if (0 === data.errcode) {
                this.$message.success("恭喜你，学时提交成功");

                this.formInline.contents = "";
                this.formInline.meterial = "";
                this.fileList = [];
              } else {
                this.$message.error(data.msg || "很抱歉，系统繁忙，请稍后再试");
              }
            });
        } else {
          return false;
        }
      });
    },
    handleCancel() {
      this.previewVisible = false;
    },
    async handlePreview(file) {
      if (!file.url && !file.preview) {
        file.preview = await getBase64(file.originFileObj);
      }
      this.previewImage = file.url || file.preview;
      this.previewVisible = true;
    },
    handleChange({ fileList }) {
      this.fileList = fileList;
    },
  },
};
</script>